// schema
import * as ISchema from "@schema";

function genericGetSetting(org: ISchema.IOrg, key: string) {
  if (!org || !org.settings || !org.settings.edges) {
    return;
  }
  const settingEdge = org.settings.edges.find((edge) => edge.node.key.name === key);
  return (settingEdge && settingEdge.node) || undefined;
}

export const KEY_NAMES = {
  ChromeExtensionInstalled: "ChromeExtensionInstalled",
  LastViewedFeedMillis: "LastViewedFeedMillis",
  ReceiveDefragMoveValueSummaryEmail: "ReceiveDefragMoveValueSummaryEmail",
  ReceiveInviteSuggestionsEmail: "ReceiveInviteSuggestionsEmail",
  ReceiveNowOnAutopilotEmail: "ReceiveNowOnAutopilotEmail",
  ReceiveWeekInReviewEmail: "ReceiveWeekInReviewEmail",
  SendNowOnAutopilotEmail: "SendNowOnAutopilotEmail",
};

function generateBooleanSetting(name: string) {
  return {
    get: (org: ISchema.IOrg) => {
      return genericGetSetting(org, name);
    },
    isOn: (org: ISchema.IOrg) => {
      const setting = genericGetSetting(org, name);
      return !!setting && setting.value[0] === "true";
    },
  };
}

export const chromeExtensionInstalledSetting = generateBooleanSetting(
  KEY_NAMES.ChromeExtensionInstalled,
);
export const receiveDefragMoveValueSummaryEmailSetting = generateBooleanSetting(
  KEY_NAMES.ReceiveDefragMoveValueSummaryEmail,
);
export const receiveInviteSuggestionsEmailSetting = generateBooleanSetting(
  KEY_NAMES.ReceiveInviteSuggestionsEmail,
);
export const receiveNowOnAutopilotEmailSetting = generateBooleanSetting(
  KEY_NAMES.ReceiveNowOnAutopilotEmail,
);
export const receiveWeekInReviewEmailSetting = generateBooleanSetting(
  KEY_NAMES.ReceiveWeekInReviewEmail,
);
export const sendNowOnAutopilotEmailSetting = generateBooleanSetting(
  KEY_NAMES.SendNowOnAutopilotEmail,
);

export const lastViewedFeedMillisSetting = {
  get: (org: ISchema.IOrg | null) => {
    if (!org) {
      return;
    }
    return genericGetSetting(org, KEY_NAMES.LastViewedFeedMillis);
  },
  getMillis: (org: ISchema.IOrg): number => {
    const setting = genericGetSetting(org, KEY_NAMES.LastViewedFeedMillis);
    return (setting && parseInt(setting.value[0])) || 0;
  },
};
